"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var state_1 = require("./compare/state");
function App(props) {
    var state = (0, state_1.useStateValue)().state;
    return (React.createElement(React.Fragment, null, props.children));
}
exports.default = App;
